import React from 'react'
import { memo } from '~/ui/component'
import { Panel, VBox } from '~/ui/components'
import { layout } from '~/ui/styling'
import { useHomeScreenWidgets } from './HomeScreenWidgetContext'
import HomeScreenWidgetsList from './HomeScreenWidgetsList'
import HomeScreenWidgetForm from './HomeScreenWidgetForm'
import HomeScreenWidgetsToolbar from './HomeSceenWidgetsToolbar'

const HomeScreenWidgetsBody = memo('HomeScreenWidgetsBody', () => {

  const {formOpen, closeForm, configuringItemIndex, newWidgetType} = useHomeScreenWidgets()

  //------
  // Rendering

  function render() {
    return (
      <VBox flex gap={layout.padding.s}>
        <Panel flex semi={false}>
          <HomeScreenWidgetsList />
        </Panel>
        <HomeScreenWidgetsToolbar />
        <HomeScreenWidgetForm
          open={formOpen}
          requestClose={closeForm}
          index={configuringItemIndex}
          type={newWidgetType}
        />
      </VBox>
    )
  }

  return render()

})

export default HomeScreenWidgetsBody